module.exports = __webpack_public_path__ + "static/img/enterprisea.e69a60c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/enterprisea.jpg
// module id = amt+
// module chunks = 1